import FolderView from './FolderView';
import findTemplateOnFolder from './utils/findTemplateOnFolder';

export default FolderView;
export { findTemplateOnFolder };
